import { TabMenu } from 'primereact/tabmenu';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import "./ConfBar.css";
import { MenuItems } from "./MenuItems";
import { MenuItems2 } from "./MenuItems2";
import { MenuItems3 } from "./MenuItems3";
import { MenuItems4 } from "./MenuItems4";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : ConfBar
Description : Tren de navegación módulo de novedades
Date Autor Modification
================================================================================
26/10/2021 Santiago Coca Rojas Creación – Se implementa el tren de navegación desde cero.
2/11/2021 Cristian Andres Pizo Mina – Se modifico las direcciones de /Stactic y /Vacation.
02/03/2022 Santiago Coca Rojas Documentación - Se documenta el componente teniendo los cambios realizados con PrimeReact
================================================================================ */

function ConfBar() {

    /*Propiedades del componente*/
    const location = useLocation();
    const [activeIndex, setActiveIndex] = useState("")
    const [items, setItems] = useState([]);

    useEffect(() => {
        const template = async () => {
            if (location.pathname.match(/Overtime/) || location.pathname.match(/Reported/) ||
                location.pathname.match(/Static/) || location.pathname.match(/Vacation/) ||
                location.pathname.match(/Licenses/)) {
                setItems(MenuItems)
            }
            if (location.pathname.match(/OpenPayroll/) || location.pathname.match(/HistoricPayroll/) ||
                location.pathname.match(/HistoricSocialSecurity/) || location.pathname.match(/HistoricAccounting/) ||
                location.pathname.match(/HistoricElectronicPayroll/)) {
                setItems(MenuItems2)
            }
            if (location.pathname.match(/Cost_center/) || location.pathname.match(/AccountantAccount_Plan/)
                || location.pathname.match(/AccountantThird/)) {
                setItems(MenuItems3)
            } if (location.pathname.match(/Users/) || location.pathname.match(/Password_management/)) {
                setItems(MenuItems4);
            }
            try {
                let route = items.filter((i) => window.location.pathname.includes(i.url))
                setActiveIndex(route[0].index)
            }
            catch (err) {
                console.log("Wait")
            }
        }
        template()
    }, [items])


    if (!(location.pathname.match(/Overtime/) || location.pathname.match(/Reported/) ||
        location.pathname.match(/Static/) || location.pathname.match(/Vacation/) ||
        location.pathname.match(/Licenses/) || location.pathname.match(/Cost_center/) ||
        location.pathname.match(/Account_Plan/) || location.pathname.match(/AccountantThird/) ||
        location.pathname.match(/Users/) || location.pathname.match(/Password_management/) ||
        location.pathname.match(/Certificate/) || location.pathname.match(/Voucher/) ||
        location.pathname.match(/OpenPayroll/) || location.pathname.match(/HistoricPayroll/) ||
        location.pathname.match(/HistoricSocialSecurity/) || location.pathname.match(/HistoricAccounting/) ||
        location.pathname.match(/HistoricElectronicPayroll/))) {

        return null;
    }
    else {
        var r = document.querySelector(':root');
        r.style.setProperty('--num-columns2', items.length);
        return (
            <div className="divbar surface-100 inline-flex">
                <TabMenu className="confbar w-max align-items-center justify-content-center pl-3" model={items} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} />
            </div>
        )
    }
}

export default ConfBar